<template>
    <div class="w-full px-6 border-l-4 rounded-r-md" :class="color">
        <div class="flex items-center py-4">
            <svg
                class="w-16 h-16 mr-8"
                style="min-width: 4rem"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                ></path>
            </svg>
            <!-- <i class="text-4xl text-gray-700 fill-current fas fa-info-circle"></i> -->
            <div>
                <h1 class="text-base font-bold">{{ title }}</h1>
                <!-- <p class="my-0 text-gray-700">
          Veillez à la complémentarité des associés.
        </p>-->
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ""
        },
        color: {
            type: String,
            default: "bg-blue-100 border-blue-500"
        }
    }
};
</script>

<style></style>
